import { PredefinedRoles } from 'constants/constants';
import { getRole } from 'utility/decode-jwt';

const isSuperAdminUser = () => {
  const roles = getRole();
  const userRoles = Array.isArray(roles) ? roles : [roles];
  return userRoles.some(role => role === PredefinedRoles.SUPER_ADMINISTRATOR);
};

export default isSuperAdminUser;
